
export const environment = {
    production: true,
    baseUrl: "https://supersonic.agilitygis.com/api",
    integrationUrl: 'https://supersonic-integration.agilitygis.com/api',
    // strapiUrl: 'https://successful-symphony-95318cafc8.strapiapp.com/api',
    // strapiJWTToken: 'Bearer 8fd34781ff2bab8395c67ef0e94158e0e56858e68436b7dc1d518512cc51db9a87e44e9089462a98aef90ab2564f3628ba3667344c4bfb429882c741475660b463918ca8c665f43c7017e79ca542bfda624a0258b97d5b7d7bc4bfe36a8cac7f821ef9bdae0dfc2fdcc418e28ec8a7b82c044c1eb9caa19880f22b122a1d4aff',
    strapiUrl: 'https://supersonic.sudosky.com/api',
    strapiJWTToken: 'Bearer 6ebb671412e42506d0b09bfd5881d9bb9891ba902c549d2cb31b3b86881a49ce28aeb3b16eb1a79e9e9e155b34651c93f0a8dff47de565863442c605a7b982d84fdc9a22fa0ec00944cb99ee8a88399546a79c5b30928182ec36bd4882a943f317314b1fdf608a08b7a22d42c590f34874529b464204ff9f72db245fac078433',
    recaptchaSiteKeyTest: '6Ld2I9QpAAAAADAclUIc6bCMfXPxb4vki2fP9It-',
    googleAnalyticsCode: 'GTM-MBHQ44Z3'
    
};


